export default __webpack_public_path__ + "static/media/iconfont.fd9f08db.ttf";